export default __webpack_public_path__ + "static/media/hht2_ep06_book_wp_02.a2e33b53.jpg";